import { Component, inject } from '@angular/core'
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { Router, RouterLink } from '@angular/router'

import { MsalService } from '@azure/msal-angular'
import { TranslatePipe } from '@ngx-translate/core'
import { CheckboxModule } from 'primeng/checkbox'

import { ButtonComponent } from 'app/_shared/components/button/button.component'
import { InputComponent } from 'app/_shared/components/input/input.component'
import { SsoConfig } from 'app/_shared/interfaces/SsoConfig'
import { CheckoutService } from 'app/_shared/services/checkout.service'
import { LogoService } from 'app/_shared/services/logo.service'
import { OktaAuthService } from 'app/_shared/services/okta-auth.service'
import { ToastService } from 'app/_shared/services/toast.service'
import { AppConfigService } from 'app/app-config.service'
import { ConfigStore } from 'app/store/config.store'

@Component({
  selector: 'app-private',
  imports: [
    CheckboxModule,
    FormsModule,
    TranslatePipe,
    ReactiveFormsModule,
    RouterLink,
    InputComponent,
    ButtonComponent
  ],
  templateUrl: './private.component.html',
  styleUrl: './private.component.scss'
})
export class PrivateComponent {
  private appConfigService = inject(AppConfigService)
  private checkoutService = inject(CheckoutService)
  private router = inject(Router)
  private toastService = inject(ToastService)
  private msalService = inject(MsalService)
  private oktaAuthService = inject(OktaAuthService)
  configStore = inject(ConfigStore)
  readonly logo = inject(LogoService)

  storefrontId = this.appConfigService.getAppConfig?.id
  serverErrors: { [key: string]: any } = {}
  protected loading: boolean = false
  private sso: SsoConfig | undefined = this.appConfigService.getAppConfig?.sso
  ssoEnabled = this.sso?.enabled ?? false
  ssoProvider = this.sso?.provider
  promoCodeAccess = this.appConfigService.getAppConfig?.private_promo_code ?? false
  passwordAccess = this.appConfigService.getAppConfig?.private_password ?? false

  form = new FormGroup({
    card: new FormControl('', {
      validators: [Validators.required]
    })
  })

  onSubmit() {
    if (!this.form.valid) {
      this.form.markAllAsTouched()
      return
    }

    if (this.form.value.card) {
      localStorage.setItem('giftCard', this.form.value.card)
      this.checkoutService.checkCouponCode(this.storefrontId, this.form.value.card).subscribe({
        next: () => {
          this.router.navigate([''])
        },
        error: err => {
          this.toastService.error(err?.error?.message || 'Not a valid gift card')
        }
      })
    }
  }

  onMicrosoftEntraLogin() {
    const state = JSON.stringify({ subdomain: window.location.hostname })
    this.msalService.loginRedirect({
      scopes: ['user.read'],
      state,
      redirectStartPage: window.location.origin
    })
  }

  onOktaLogin() {
    this.oktaAuthService.loginRedirect().catch(error => {
      console.error('Okta login redirect error:', error)
    })
  }

  get storeName(): string {
    return this.appConfigService.getAppConfig?.name?.trim() ?? ''
  }

  get storeWelcome(): string {
    // Title-case each word: “nike outlet” → “Nike Outlet”
    const title = this.storeName.replace(
      /\w\S*/g,
      w => w[0].toUpperCase() + w.slice(1).toLowerCase()
    )

    const alreadyHasStore = /\bstore\b/i.test(title)
    return `Welcome to ${title}${alreadyHasStore ? '' : ' Store'}!`
  }
}
